<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header title="Folios" :breadcrumbs="breadcrumbs" :hiddenTab="true" :dense="true">
      <template v-slot:main>
        <v-btn class="mr-2" @click="dialogConfFolio=true" outlined color="secondary"><v-icon left>mdi-cog</v-icon>Configuración</v-btn>
        <v-btn v-if="$helpers.hasPermission(['add_caf'])" color="primary" @click="dialogCreateFolio=true"><v-icon left>mdi-file-plus</v-icon>Cargar folios</v-btn>
      </template>
    </mini-header>
    <!-- end header -->
    <!-- <PermissionDenied v-if="!$helpers.hasSomePermission(['view_caf'])" /> -->
    <v-col cols="12" class="px-0">
      <v-skeleton-loader class="elevation-0" type="table" v-if="loading" />
      <template v-else>
        <v-empty-state v-if="!allCafsList.length" title="No existen folios para mostrar" type="documents" id="folios" :isFree="true" customClass="mt-n8">
          <!-- <template v-slot:actions>
            <v-btn @click="activeFilter = true" color="primary" :ripple="false" :width="153"><v-icon class="mr-2">mdi-filter-plus</v-icon>Filtrar</v-btn>
            <v-btn class="ml-2" @click="setSort('-date')" outlined :ripple="false" width="153"><v-icon class="mr-2">mdi-text-search-variant</v-icon>Últimos registros</v-btn>
          </template> -->
        </v-empty-state>
        <template v-else>
          <v-data-table class="table-condense d-none" :headers="currentHeader" :items="allCafsList" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(item) => $router.push({ name: 'FoliosRetrieve', params: { id: item.document_type } }).catch(() => {})" style="cursor:pointer">
            <template v-slot:header="{ props: { headers } }">
              <VTableHeaders :headers="headers" />
            </template>

            <template v-slot:[`item.document_type`]="{item}">
              <span v-if="item.document_type" style="white-space: normal !important">{{item.document_type | nameDocumentsType}}</span>
              <span class="body-2 text--disabled" v-else>Sin especificar</span>
            </template>

            <template v-slot:[`item.total`]="{item}">
              <span class="body-1 font-weight-bold" v-if="item.total">{{item.total}}</span>
              <span class="body-2 text--disabled" v-else>Sin especificar</span>
            </template>

            <template v-slot:[`item.used`]="{item}">
              <span class="text--secondary font-weight-medium" v-if="item.used">{{item.used}}</span>
              <span class="body-2 text--disabled" v-else>Sin especificar</span>
            </template>

            <template v-slot:[`item.available`]="{item}">
              <span class="text--secondary font-weight-medium" v-if="item.available">{{item.available}}</span>
              <span class="body-2 text--disabled" v-else>Sin especificar</span>
            </template>

            <template v-slot:[`item.available_to_give`]="{item}">
              <v-icon v-if="!item.available_to_give" color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="secondary">mdi-minus</v-icon>
            </template>

            <template v-slot:[`item.available_to`]="{item}">
              <v-icon v-if="item.available_to_give" color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="secondary">mdi-minus</v-icon>
            </template>

            <template v-slot:[`item.status`]="{item}">
              <v-chip v-if="item.status === 'normal'" color="green lighten-1" dark small>Normal</v-chip>
              <v-chip v-else-if="item.status === 'alert'" color="orange lighten-1" dark small>Alerta</v-chip>
              <v-chip v-else-if="item.status === 'risk'" color="red lighten-1" dark small>Crítico</v-chip>
              <span class="body-2 text--disabled" v-else>Sin especificar</span>
            </template>
          </v-data-table>
          <v-row>
            <v-col v-for="(caf, index) in allCafsList" :key="`${caf.id}-${index}`" cols="4" md="3" :lg="$vuetify.breakpoint.width > 1200 ? 3 : 2">
              <v-hover v-slot="{ hover }">
                <v-card class="pa-5 rounded-md" :elevation="hover ? 5 : 0" flat :to="{name: 'FoliosRetrieve', params: {id: caf.document_type}}">
                  <v-row no-gutters>
                    <v-avatar class="mb-2" color="#D0DCF3" size="36">
                      <v-icon color="primary" size="20">mdi-file-document</v-icon>
                    </v-avatar>
                    <v-spacer />
                    <v-btn :to="{name: 'FoliosRetrieve', params: {id: caf.document_type}, query: {isAdmin: true}}" outlined color="secondary"><v-icon left>mdi-cog</v-icon>Administrar</v-btn>
                  </v-row>
                  <!-- <span class="d-block mt-3"> -->
                  <v-sheet class="transparent mt-3 mb-4" height="25">
                    <span v-if="caf.document_type.length" class="secondary--text font-weight-semibold subtitle-2 d-inline-block text-truncate" style="max-width: 99%;">{{caf.document_type | nameDocumentsType}}</span>
                    <span class="d-block mt-n1 body-2 text--disabled" v-else>Sin especificar</span>
                  <!-- </span> -->
                  <span v-if="caf.total" class="d-block body-1 fontDraw--text d-inline-block text-truncate" style="max-width: 99%;">Cantidad cargada: {{caf.total | number}}</span>
                  <span class="d-block body-1 fontDraw--text" v-else>Nunca utilizado</span>
                  </v-sheet>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </template>
    </v-col>
 <!-- dialog create folio -->
 <v-dialog v-model="dialogCreateFolio" width="850" persistent no-click-animation scrollable overlay-color="overlay">
      <v-card flat>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--secondary font-weight-semibold">Cargar folios</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="clear(), dialogCreateFolio=false" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-1 pb-4 px-0">
          <v-row class="px-5" align="center" no-gutters>
            <v-col cols="4" class="mt-7">
              <img :src="require(`@/assets/backgrounds/modal-folios-upload.svg`)" :width="250" />
            </v-col>
            <v-col class="pl-10">
              <div class="mt-5">
                <span class="d-block mt-3 body-1 fontBody--text font-weight-bold mb-2">Archivo de folios (CAF)</span>
                <v-file-input class="ml-n1 custom-file" v-model="newCaf.file" ref="newCaf" type="file" :key="!newCaf.file?.length" :error="$v.newCaf.file.$error" accept=".xml" background-color="transparent" hide-details solo flat chips style="z-index: 10" />
                <span class="mt-2 mx-auto text-center transparent custom-text-file" v-if="!newCaf.file" style="position: absolute; top: 100px; z-index: 0; left: 320px; right: 50px">
                  <v-icon size="36" color="secondary">mdi-cloud-upload-outline</v-icon>
                  <span class="d-block my-1 body-1 fontBody--text font-weight-semibold">Haz click para seleccionar un archivo </span>
                  <span class="d-block body-2">o arrastra el archivo aquí (xml)</span>
                </span>
                <span class="d-block mt-10 body-1 fontBody--text font-weight-bold">Uso de folios</span>
                <span class="body-2 mt-1 d-block">Selecciona el esquema de emisión bajo el cual se utilizarán estos folios.</span>
                <v-item-group :key="reset">
                  <v-container class="px-0">
                    <v-row>
                      <v-col cols="6" clas="pa-0">
                        <v-item v-slot="{ active, toggle }">
                          <v-card
                            height="90"
                            @click="toggle(), newCaf.available_to_give = false"
                            outlined
                            flat
                            rounded="sm"
                            :ripple="false"
                            :style="`border: 1px solid var(${active ? '--light-blue-primary' : '--light-blue-grey'})`"
                          >
                          <v-card-title class="pa-0">
                            <v-toolbar flat height="18" class="transparent">
                              <v-spacer />
                              <v-toolbar-items>
                                <v-row align="center" justify="center" class="mr-2 pt-3">
                                  <v-tooltip color="bgSearch" right transition="scale-transition" :max-width="150">
                                    <template v-slot:activator="{on}">
                                      <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                    </template>
                                    <span class="d-block px-3 py-2">El uso estará destinado a la emisión de documentos a través de agente y SOAP.</span>
                                  </v-tooltip>
                                </v-row>
                              </v-toolbar-items>
                            </v-toolbar>
                          </v-card-title>
                          <v-card-text class="pa-0 d-flex align-center">
                            <div class="flex-grow-1 text-center">
                              <v-icon color="primary" size="25">mdi-server-network</v-icon>
                              <span class="text-body-2 fontDraw--text d-block mt-3">Emisión vía agente o webservice</span>
                            </div>
                          </v-card-text>
                          </v-card>
                        </v-item>
                      </v-col>
                      <v-col cols="6" clas="pa-0">
                        <v-item v-slot="{ active, toggle }">
                          <v-card
                            height="90"
                            @click="toggle(), newCaf.available_to_give = true"
                            outlined
                            flat
                            rounded="sm"
                            :ripple="false"
                            :style="`border: 1px solid var(${active ? '--light-blue-primary' : '--light-blue-grey'})`"
                          >
                            <v-card-title class="pa-0">
                              <v-toolbar flat height="18" class="transparent">
                                <v-spacer />
                                <v-toolbar-items>
                                  <v-row align="center" justify="center" class="mr-2 pt-3">
                                    <v-tooltip color="bgSearch" left transition="scale-transition" :max-width="150">
                                      <template v-slot:activator="{on}">
                                        <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                      </template>
                                      <span class="d-block px-3 py-2">El uso estará destinado a la emisión de documentos a través de API-REST y facturador manual.</span>
                                    </v-tooltip>
                                  </v-row>
                                </v-toolbar-items>
                              </v-toolbar>
                            </v-card-title>
                            <v-card-text class="pa-0 d-flex align-center">
                              <div class="flex-grow-1 text-center">
                                <v-icon color="primary" size="25">mdi-monitor-dashboard</v-icon>
                                <span class="text-body-2 fontDraw--text d-block mt-3">Emisión vía plataforma</span>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="text-right py-2 px-5">
          <v-spacer />
          <v-btn @click="clear(), dialogCreateFolio=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="dialogCreateFolio=false, dialogConfirm=true" :disabled="newCaf.available_to_give === null || newCaf.file === null" color="primary">Cargar folios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create folio -->

    <!-- dialog confirm create-->
    <v-dialog v-model="dialogConfirm" width="650" persistent no-click-animation overlay-color="overlay">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--text font-weight-semibold">Confirmar carga</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="clear(), dialogConfirm=false" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 fontBody--text">
          <v-row class="pt-2 pb-2" align="center">
            <v-col cols="4">
              <img :src="require(`@/assets/backgrounds/modal-folios-upload.svg`)" :width="180" />
            </v-col>
            <v-col class="pr-3 pl-1">
              <span class="d-block text-body-1">Al confirmar, se realizará la carga de tus folios</span>
              <div class="d-flex align-center mt-5">
                <v-icon color="secondary" size="16" left>mdi-{{ newCaf.available_to_give ? 'monitor-dashboard' : 'server-network'}}</v-icon>
                <span class="d-block text-body-1">
                  <span class="font-weight-bold">Uso de folios:</span>
                  {{ !newCaf.available_to_give ? 'Agente/Webservice' : 'Plataforma' }}
                </span>
              </div>
              <!-- <div class="d-flex align-center mt-2">
                <v-icon color="secondary" size="16" left>mdi-file-document</v-icon>
                <span class="d-block text-body-1">
                  <span class="font-weight-bold">Tipo de documento:</span>
                  <span class="body-2 text--disabled">Sin especificar</span>
                </span>
              </div>
              <div class="d-flex align-center mt-2">
                <v-icon color="secondary" size="16" left>mdi-file-document-multiple</v-icon>
                <span class="d-block text-body-1">
                  <span class="font-weight-bold">Cantidad de folio</span>
                  <span class="body-2 text--disabled">Sin especificar</span>
                </span>
              </div> -->
              <span class="d-block text-body-1 mt-5 mb-3">Escribe <span class="font-weight-bold">“confirmar”</span> para continuar.</span>
              <v-text-field v-model="confirm" outlined single-line maxlength="9" dense hide-details />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="clear(), dialogConfirm=false" outlined>Cancelar</v-btn>
          <v-btn color="primary" @click="dialogConfirm=false" :loading="$store.state.irs.createLoader" :disabled="confirm.toLowerCase() !== 'confirmar' ">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog confirm create -->

    <!-- dialog conf folio -->
    <v-dialog v-model="dialogConfFolio" width="932" persistent no-click-animation scrollable overlay-color="overlay">
      <v-card flat :key="dialogConfFolio===false">
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--secondary font-weight-semibold">Configuración de folios</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="handlerCloseConfigDialog" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <div class="d-flex">
            <div style="flex:0;">
              <v-navigation-drawer class="pa-5 drawer-folios" permanent width="267">
                <v-list-item-title class="subtitle-2 secondary--text font-weight-medium mb-4 d-flex align-center">
                  <v-icon color="secondary" small left>mdi-file-document</v-icon>
                  Tipo de documento
                </v-list-item-title>
                  <div v-for="(dte, index) in documentTypes" :key="dte.id" :class="['ml-2', {'pb-4' : documentTypes.length - 1 !== index}]" style="border-left: 1px solid var(--light-blue-grey)">
                    <v-list-item :class="['mx-2', {'active-list primary--text font-weight-medium' : configFolio.document_type.name === dte.name}]" @click="configFolio.document_type=dte" :ripple="false" exact style="min-height: 25px;">
                      <v-list-item-title class="px-2" style="white-space: normal">{{ dte.name }}</v-list-item-title>
                    </v-list-item>
                  </div>
              </v-navigation-drawer>
            </div>
            <div class="px-5 py-5" style="flex:1; min-width: 300px">
              <!-- charging auto-->
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-list class="px-5 transparent v-form-list" max-width="100%">
                    <v-list-item>
                      <v-list-item-title class="body-1 fontBody--text font-weight-bold d-flex align-center">
                        <v-icon color="secondary" size="18" left>mdi-refresh-auto</v-icon>
                        Autorización y carga automática de folios
                      </v-list-item-title>
                      <v-list-item-action class="ma-0">
                        <v-switch class="ma-0" v-model="showAuto" hide-details :ripple="false "/>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <template v-if="showAuto">
                    <v-divider />
                    <v-row class="pa-5" align="center" no-gutters>
                      <span>Cuando el número de folios restantes sea</span>
                      <v-col cols="1" class="pa-0 mx-3">
                        <v-text-field v-model="configFolio.min_available" :error="$v.configFolio.min_available.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" height="26" outlined single-line solo flat dense hide-details />
                      </v-col>
                      <span>se deben solicitar</span>
                      <v-col cols="1" class="pa-0 mx-3">
                        <v-text-field v-model="configFolio.quantity" :error="$v.configFolio.quantity.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" height="26" outlined single-line solo flat dense hide-details />
                      </v-col>
                      <span>folios.</span>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
              <!-- end charging auto -->

              <!-- notification-->
              <v-card flat class="mt-5">
                <v-card-title class="pa-0">
                  <v-toolbar flat height="46" class="transparent">
                    <v-toolbar-title class="px-4 subtitle-2 fontBody--secondary font-weight-semibold">
                      <v-icon color="secondary" size="18" left>mdi-bell</v-icon>Notificaciones
                    </v-toolbar-title>
                  </v-toolbar>
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-0">
                  <v-list class="transparent v-form-list" max-width="100%">
                    <v-list-item class="px-5">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-2 fontBody--text font-weight-bold d-flex align-center">Disponibilidad de folios</v-list-item-title>
                        <v-list-item-subtitle class="body-1 mt-1">Recibe notificaciones sobre la cantidad restante de folios</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action class="ma-0">
                        <v-switch class="ma-0" v-model="newCaf.available_to_give" hide-details />
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-1"/>
                    <v-list-item class="px-5">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-2 fontBody--text font-weight-bold d-flex align-center">Vencimiento de folios</v-list-item-title>
                        <v-list-item-subtitle class="body-1 mt-1">Recibe notificaciones sobre el vencimiento de los folios</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action class="ma-0">
                        <v-switch class="ma-0" v-model="newCaf.date" hide-details />
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
              <!-- end notification -->

              <!-- recipients-->
              <v-card flat class="mt-5" v-if="$helpers.hasPermission(['view_member'])">
                <v-card-title class="pa-0">
                  <v-toolbar flat height="46" class="transparent">
                    <v-toolbar-title class="px-4 subtitle-2 fontBody--secondary font-weight-semibold">
                      <v-icon color="secondary" size="18" left>mdi-account-multiple</v-icon>Destinatarios
                    </v-toolbar-title>
                  </v-toolbar>
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-0 pb-4">
                  <v-list-item class="px-5 my-0" three-line>
                    <v-list-item-content class="py-0">
                      <v-list-item-subtitle class="body-1">Selecciona a qué usuarios se les enviarán notificaciones sobre los folios de {{configFolio?.document_type?.name}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-col class="px-5 mt-n7" cols="8">
                    <v-autocomplete
                      v-model="configFolio.mails"
                      :error="$v.configFolio.mails.$error"
                      hide-details
                      single-line
                      color="primary"
                      dense
                      outlined
                      :items="membersList"
                      multiple
                      :chips="false"
                      item-text="email"
                      item-value="email"
                      :label="(configFolio.mails || []).length ? '' : 'Selecciona a los usuarios'"
                      :prefix="(configFolio.mails || []).length >= 1 ? `${(configFolio.mails || []).length === 1 ? `${(configFolio.mails || []).length} seleccionado` : `${(configFolio.mails || []).length} seleccionados`}` : ''"
                      no-data-text="No existen usuarios para mostrar"
                    >
                      <template v-slot:selection="{ props }">
                        <span v-if="props" style=""></span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-row no-gutters>
                    <v-col class="px-5">
                      <v-chip class="mr-2 mb-2 font-weight-light text-lowercase overline chip-users" v-for="(m, i) in configFolio.mails" :key="`${m}${i}`" close @click:close="memberRemove(m, 0)" color="lightBlue" small label close-icon="mdi-close">
                        {{m }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <!-- end recipients -->
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="text-right py-2 px-5">
          <v-spacer />
          <v-btn @click="handlerCloseConfigDialog" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createConfig" :loading="loadingConfig" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog conf folio -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import folios from '@/data/foliosList'
import members from '@/data/membersList'
import MiniHeader from '@/components/commons/MiniHeader'
import { required } from 'vuelidate/lib/validators'
import VEmptyState from '@/components/commons/VEmptyState'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ListViewMixin from '@/mixins/ListViewMixin'
import documentTypesList from '@/collections/documentTypes'
import PermissionDenied from '@/modules/http/views/PermissionDenied'

export default {
  components: {
    VEmptyState,
    PermissionDenied,
    MiniHeader,
    VTableHeaders: () => import('@/components/VTable/VTableHeaders')
  },
  mixins: [
    GenericViewMixin, ListViewMixin
  ],
  data: () => ({
    reset: 0,
    dialogConfirm: false,
    confirm: '',
    membersList: [],
    cafsList: [],
    loadingConfig: false,
    showAuto: true,
    configFolio: {
        document_type: {
        id: 'CL33',
        name: 'Factura electrónica'
      },
      min_available: null,
      quantity: null,
      mails: []
    },
    scroll: 0,
    loading: false,
    dialogCreateFolio: false,
    dialogConfFolio: false,
    documentTypes: documentTypesList.filter(d => d.country === 'CL'),
    guides: [
      '/guide/settings/documents/proveedores-de-facturacion/facturacion-incorporada#solicitud-de-timbraje-de-folios',
      '/guide/settings/documents/proveedores-de-facturacion/facturacion-incorporada#folios',
      '/guide/settings/documents/proveedores-de-facturacion/facturacion-incorporada#anulacion-de-folios-vencidos'
    ],
    newCaf: {
      file: null,
      available_to_give: false
    },
    headers: [
      { text: 'Tipo de documento', value: 'document_type', sortable: true },
      { text: 'Cantidad cargada', value: 'total', align: 'end', sortable: true }
      // { text: 'Usados', value: 'used', align: 'end', sortable: true },
      // { text: 'Disponibles', value: 'available', align: 'end', sortable: true },
      // { text: 'Estado', value: 'status', align: 'end' }
    ],
    columnSupport: [
      { text: 'WS/Agente', value: 'available_to_give', align: 'center' },
      { text: 'Plataforma', value: 'available_to', align: 'center' }
    ],
    statusFolios: [
       {
        id: "normal",
        name: 'Normal',
        detail: '',
        color: 'var(--axt-green-light)',
        icon: 'mdi-check',
        isLight: true
      },
      {
        id: "risk",
        name: 'Riesgo operacional',
        detail: '',
        color: 'var(--axt-red-darken)',
        icon: 'mdi-close',
        isLight: true
      }
    ],
    env: process.env?.VUE_APP_MODE ?? 'ax',
    breadcrumbs: {
      main: 'Folios',
      children: []
    },
    allCafsList: []
  }),
  computed: {
    ...mapState({
      // cafsList: state => state.irs.reportList,
      count: state => state.irs.reportCount
      // membersList: state => state.accounts.membersList
    }),
    currentHeader () {
      if (this.$store.state.auth.userAccount.is_staff) {
        return [...this.headers, ...this.columnSupport]
      }
      return this.headers
    }
  },
  created () {
    this.membersList = members
    this.cafsList = folios
    documentTypesList.filter((d) => d.country === 'CL').forEach((item) => {
      if (!this.cafsList.find((caf) => caf.document_type === item.id)) {
        this.allCafsList.push({ document_type: item.id, total: 0})
      } else {
        this.allCafsList.push(this.cafsList.find((caf) => caf.document_type === item.id))
      }
    })
    // this.getList()
    // if (this.$helpers.hasPermission(['view_member'])) {
    //   this.$store.dispatch('accounts/LIST', {
    //     resource: 'members',
    //     query: {
    //       page_size: 9999,
    //       is_active: true
    //     }
    //   })
    // }
  },
  methods: {
    clear () {
      this.reset += 1
      this.newCaf.file = null
      this.newCaf.available_to_give = null
      this.confirm = ''
    },
    memberRemove (item) {
      this.configFolio.mails = [...this.configFolio.mails.filter((m) => m !== item)]
    },
    onScroll (e) {
      this.offsetTop = e.target?.scrollingElement?.scrollTop ?? 0
    },
    getList () {
      if (this.$helpers.hasPermission(['view_caf'])) {
        this.loading = true
        this.$store.dispatch('irs/LIST', {
          resource: 'irs/sii/cafs/report'
          // query: {
          //   document_type: 'CL61'
          //   // page_size: 100
          // }
        })
        // .then(() => {
        // })
        .finally(() => {
          this.loading = false
        })
      }
    },
    createConfig () {
      this.$v.configFolio.$touch()
      if (this.$v.configFolio.$invalid) {
        return false
      }

      this.loadingConfig = true

      const payload = {
        min_available: this.configFolio.min_available,
        quantity: this.configFolio.quantity,
        document_type: this.configFolio.document_type.id,
        mails: this.configFolio.mails
      }

      this.$store.dispatch('irs/CREATE', {
        resource: 'irs/sii/config_auto_caf',
        payload: payload
      })
      .then(() => {
        this.$dialog.message.info('Configuración guardada correctamente')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loadingConfig = false
        this.handlerCloseConfigDialog()
      })
    },
    createCaf () {
      this.$v.newCaf.$touch()
      if (this.$v.newCaf.$invalid) {
        return false
      }
      const payload = new FormData()
      payload.append('file', this.newCaf.file, this.newCaf.file.name)
      payload.append('available_to_give', !(this.newCaf.available_to_give === 'true'))

      this.$store.dispatch('irs/CREATE', {
        resource: 'irs/sii/cafs',
        payload: payload,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(() => {
        this.$dialog.message.info('Folio guardado correctamente')
        this.getList()
        this.dialogCreateFolio = false
        this.newCaf.file = null
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      // .finally(() => {
      //   this.dialogCreateFolio = false
      // })
    },
    handlerCloseConfigDialog () {
      this.dialogConfFolio = false
      this.configFolio = {
        min_available: null,
        quantity: null,
        document_type: {
          id: 'CL33',
          name: 'Factura electrónica'
        },
        mails: []
      }
      this.$v.configFolio.$reset()
    }
  },
  validations: {
    newCaf: {
      file: {
        required
      }
    },
    configFolio: {
      document_type: {
        required
      },
      mails: {
        required
      },
      quantity: {
        required
      },
      min_available: {
        required
      }
    }
  }
}
</script>